export default __webpack_public_path__ + "static/media/CA-14 reveal access token page.a627b4ac.png";